module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"paymentFailed":"Нам не удалось произвести списание с карты. Попробуйте выбрать другой способ оплаты.","paymentFailedTitle":"Платёж не прошел"}}')
  delete Component.options._Ctor
}
